import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            display: 1,
            seq:0,

            eng:'',
            kor:'',
            cn:'',
        }
    },
    validators: {
        eng: function (value) {
            return Validator.value(value)
                .required('주제명(영어)를 입력해주세요.')
        },
        kor:function (value) {
            return Validator.value(value)
                .required('주제명(한국어)를 입력해주세요.')
        },
        cn: function (value) {
            return Validator.value(value)
                .required('주제명(중국어)를 입력해주세요.')
        },
        display: function (value) {
            return Validator.value(value)
                .required('노출여부를 선택해주세요.')
        },
        seq : function (value) {
            return Validator.value(value)
                .required('순서를 입력해주세요')
                .integer('숫자만 입력이 가능합니다.')
        },
    }
}
